export default {"src":"/_next/static/image/public/images/ic_guest_records.004d5d241f6472d200db1ff049ae6bfb.svg","height":168,"width":152};